const ApplicationWrapper = props => {

    return (
        <div className={ `application-wrapper-container${props.screenMode ? ' full-screen' : '' }` }>
            { props.children }
        </div>
    )
}

export default ApplicationWrapper